import {
  GET_CARS_LIST_OF_VENDOR,
  GET_CARS_LIST_OF_VENDOR_SUCCESS,
  GET_CARS_LIST_OF_VENDOR_ERROR,
  GET_CARS_LIST_OF_VENDOR_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCarsListOfVendor = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARS_LIST_OF_VENDOR:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CARS_LIST_OF_VENDOR_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CARS_LIST_OF_VENDOR_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CARS_LIST_OF_VENDOR_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCarsListOfVendor;
